import { Component, OnInit, Input } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { GlobalService } from '@common/global';
import { ViewService } from '@services/view.service';
import { SaveService } from '@services/save.service';
import * as _ from 'lodash';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
@Component({
  selector: 'app-dmemberimageupdate',
  templateUrl: './dmemberimageupdate.component.html',
  styleUrls: ['./dmemberimageupdate.component.sass']
})
export class DmemberimageupdateComponent implements OnInit {
  @Input('res') res: object;
  component = "";
  application = "";
  response: any = [];
  status = "";
  name = "";
  bio: any = [];
  member_id = '';
  public config: DropzoneConfigInterface = {
    acceptedFiles: 'image/*',
    clickable: true,
    maxFiles: 1
  };
  constructor(private _save: SaveService, private _viewService: ViewService, private _global: GlobalService, public ngxSmartModalService: NgxSmartModalService) {

    this.component = this._global.COMPONENTS_SMN;
    this.application = 'member';
   
  }

  ngOnInit() {
  }
  ngOnChanges() {
    this.response = this.res;
    this.name = this._global.getVal(this.response, 'firstName', '') + "  " + this._global.getVal(this.response, 'lastName', '');
    this.member_id = this._global.getVal(this.response, 'id', '');

  }
  public onUploadInit(args: any): void {
    args["options"]["params"] = this._global.getUploadParams(this.application, this.component, this.application, this.member_id);
  }
  public onUploadError(args: any): void {
    this._global.showMessage({ type: 'warning', message: args[1] });
  }

  public onUploadSuccess(args: any): void {
    console.log("this.appCreateForm", args);

  }
  public onUploadProcessing(args: any) {


  }

  public oncUploadInit(args: any): void {
    args["options"]["params"] = this._global.getUploadParams(this.application, this.component, 'cover', this.member_id);
  }
  public oncUploadError(args: any): void {
    this._global.showMessage({ type: 'warning', message: args[1] });
  }

  public oncUploadSuccess(args: any): void {
    console.log("this.appCreateForm", args);

  }
  public oncUploadProcessing(args: any) {


  }
}
